"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

import { EVENTS_LOCATOR_BUILDER_COMPONENT_NAME } from "./EventsLocator.constants";

export const eventsLocatorInputs = [
  {
    name: "defaultLatitude",
    type: "number",
    required: true,
    defaultValue: 0,
  },
  {
    name: "defaultLongitude",
    type: "number",
    required: true,
    defaultValue: 0,
  },
  {
    name: "defaultZoom",
    type: "number",
    defaultValue: 15,
  },
  {
    name: "storesLimit",
    type: "number",
    defaultValue: 1000,
  },
] as const satisfies Inputs;

export const EventsLocatorComponent: RegisteredComponent = {
  name: EVENTS_LOCATOR_BUILDER_COMPONENT_NAME,
  component: dynamic(
    async () =>
      withValidation(
        eventsLocatorInputs,
        (await import("./EventsLocator")).EventsLocator,
        EVENTS_LOCATOR_BUILDER_COMPONENT_NAME
      ),
    { ssr: false }
  ),
  inputs: eventsLocatorInputs,
};
